export default __webpack_public_path__ + "ernie-bote321e5.png";